"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ChallengesModelForm = ChallengesModelForm;
var _CircularProgress2 = _interopRequireDefault(require("@mui/material/CircularProgress"));
var _Close2 = _interopRequireDefault(require("@mui/icons-material/Close"));
var _Card2 = _interopRequireDefault(require("@mui/material/Card"));
var _CardContent2 = _interopRequireDefault(require("@mui/material/CardContent"));
var _ButtonBase2 = _interopRequireDefault(require("@mui/material/ButtonBase"));
var _Box2 = _interopRequireDefault(require("@mui/material/Box"));
var _Typography2 = _interopRequireDefault(require("@mui/material/Typography"));
var _styles = require("@mui/material/styles");
var _moment = _interopRequireDefault(require("moment"));
var _notistack = require("notistack");
var _react = _interopRequireWildcard(require("react"));
var _reactI18next = require("react-i18next");
var _foretVierge = _interopRequireDefault(require("../assets/images/challenges/foret-vierge.png"));
var _grandeEpopee = _interopRequireDefault(require("../assets/images/challenges/grande-epopee.png"));
var _objectifLune = _interopRequireDefault(require("../assets/images/challenges/objectif-lune.png"));
var _premierDefi = _interopRequireDefault(require("../assets/images/challenges/premier-defi.png"));
var _routeDeLaSoie = _interopRequireDefault(require("../assets/images/challenges/route-de-la-soie.png"));
var _tourDeFrance = _interopRequireDefault(require("../assets/images/challenges/tour-de-france.jpg"));
var _tourDeLaTerre = _interopRequireDefault(require("../assets/images/challenges/tour-de-la-terre.png"));
var _components = require("../components");
var _hooks = require("../hooks");
var _models = require("../models");
var _services = require("../services");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const startDate = (0, _moment.default)().add(1, 'month').startOf('month');
const endDate = (0, _moment.default)().add(1, 'month').endOf('month');
function ChallengesModelForm({
  Link,
  prevPath,
  currentPartner,
  drawerWidth,
  onRedirect
}) {
  const [isSubmitting, setSubmitting] = (0, _react.useState)(false);
  const {
    t
  } = (0, _reactI18next.useTranslation)();
  const [models] = (0, _react.useState)([new _models.Challenge(1, 'traveledDistance', 'global', 'all', startDate, endDate, 'Premier défi', 'Un premier défi : parcourir ensemble 1000 kilomètres !', _premierDefi.default, null, 0, 0, 1000000, 'published', null, null), new _models.Challenge(2, 'traveledDistance', 'global', 'all', startDate, endDate, 'Le Tour de France', "Parcourez collectivement l'équivalent du parcours de la Grande Boucle !", _tourDeFrance.default, null, 0, 0, 3500000, 'published', null, null), new _models.Challenge(3, 'traveledDistance', 'global', 'all', startDate, endDate, 'Forêt vierge', "7000km, c'est la longueur du plus long fleuve du monde : l'Amazone !", _foretVierge.default, null, 0, 0, 7000000, 'published', null, null), new _models.Challenge(4, 'traveledDistance', 'global', 'all', startDate, endDate, 'La Route de la Soie', 'Suivez les routes envoûtantes de la Route de la Soie en pédalant 12 000 kilomètres !', _routeDeLaSoie.default, null, 0, 0, 12000000, 'published', null, null), new _models.Challenge(5, 'traveledDistance', 'global', 'all', startDate, endDate, 'La Grande Épopée', 'Parcourez la distance de la Muraille de Chine en pédalant 21 196 kilomètres !', _grandeEpopee.default, null, 0, 0, 21196000, 'published', null, null), new _models.Challenge(6, 'traveledDistance', 'global', 'all', startDate, endDate, 'Tour de la Terre à vélo', "Prêts à relever le défi de pédaler l'équivalent d'un tour de la Terre ?", _tourDeLaTerre.default, null, 0, 0, 40075000, 'published', null, null), new _models.Challenge(7, 'traveledDistance', 'global', 'all', startDate, endDate, 'Objectif Lune !', "Roulez pour atteindre la Lune ! L'objectif collectif est fixé à 384 400 km !", _objectifLune.default, null, 0, 0, 384400000, 'published', null, null)]);
  const [selectedModelId, selectModelId] = (0, _react.useState)(models[0].id);
  const {
    palette
  } = (0, _styles.useTheme)();
  const {
    enqueueSnackbar
  } = (0, _notistack.useSnackbar)();
  const {
    cancellablePromise,
    cancelPromises
  } = (0, _hooks.useCancellablePromise)();
  (0, _react.useEffect)(() => {
    return () => cancelPromises();
  }, []);
  async function handleSubmit() {
    if (!currentPartner) return;
    const model = models.find(({
      id
    }) => id === selectedModelId);
    if (!model) return;
    const {
      title,
      description,
      startDate,
      endDate,
      type,
      targetValue
    } = model;
    setSubmitting(true);
    try {
      let photo;
      if (model.photo) {
        const res = await fetch(model.photo, {
          method: 'GET',
          headers: {
            'Content-Type': 'image/png'
          }
        });
        const blob = await res.blob();
        photo = new File([blob], model.photo.slice(model.photo.lastIndexOf('/') + 1));
      }
      await cancellablePromise(_services.GeogroupService.addChallenge(currentPartner, {
        title,
        description,
        start_datetime: (0, _moment.default)(startDate).startOf('day').format(),
        end_datetime: (0, _moment.default)(endDate).endOf('day').format(),
        target_type: _services.backendChallengeTypes[type],
        trace_type: type === 'homeWorkJourneysCount' ? 'COMMUTING' : 'ALL',
        target_value: targetValue
      }, photo, {
        expectedStatus: 201
      }));
      enqueueSnackbar(t('commons.challenge_post.form.success'));
      onRedirect();
    } catch (err) {
      if (typeof err === 'object' && err && 'status' in err && err.status === 200 && 'message' in err && typeof err.message === 'object' && err.message && 'id' in err.message) {
        enqueueSnackbar(t('commons.challenge_post.form.server_error_already_exists'), {
          variant: 'error'
        });
        onRedirect();
      } else if (!(err instanceof Error) || err?.name !== 'CancelledPromiseError') {
        enqueueSnackbar(t('commons.challenge_post.form.server_error'), {
          variant: 'error'
        });
        setSubmitting(false);
      }
    }
  }
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_Box2.default, {
    alignSelf: "stretch",
    marginBottom: "58px"
  }, /*#__PURE__*/_react.default.createElement(_Card2.default, {
    elevation: 0,
    sx: {
      alignSelf: 'stretch',
      borderRadius: 4
    }
  }, /*#__PURE__*/_react.default.createElement(_CardContent2.default, {
    sx: {
      display: 'flex',
      flexDirection: 'column',
      gap: 3,
      padding: 3
    }
  }, /*#__PURE__*/_react.default.createElement(_Box2.default, {
    alignItems: "flex-start",
    display: "flex",
    flexDirection: {
      xs: 'column',
      md: 'row'
    },
    gap: 2,
    justifyContent: "space-between"
  }, /*#__PURE__*/_react.default.createElement(_Typography2.default, {
    fontWeight: 600,
    variant: "h6"
  }, t('commons.challenge_post.form.title_creation_model'))), /*#__PURE__*/_react.default.createElement(_Box2.default, {
    display: "flex",
    flexWrap: "wrap",
    gap: 2
  }, models.map(challenge => /*#__PURE__*/_react.default.createElement(_Box2.default, {
    display: "flex",
    flexDirection: "column",
    key: challenge.id,
    width: {
      xs: '100%',
      md: 'calc((100% - 16px) / 2)',
      lg: 'calc((100% - 32px) / 3)'
    }
  }, /*#__PURE__*/_react.default.createElement(_ButtonBase2.default, {
    disabled: isSubmitting,
    onClick: () => selectModelId(challenge.id),
    sx: {
      borderRadius: 4,
      '.challenge-card': {
        cursor: 'pointer'
      }
    }
  }, /*#__PURE__*/_react.default.createElement(_components.ChallengeCard, {
    disableLink: true,
    isModel: true,
    challenge: challenge,
    containerProps: challenge.id === selectedModelId ? {
      border: `2px solid ${palette.primary.main}`
    } : {
      border: `1px solid #e3e7ee`,
      margin: '1px'
    }
  })))))))), /*#__PURE__*/_react.default.createElement(_components.StickyBar, {
    drawerWidth: drawerWidth
  }, /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_components.Button, {
    color: "primary",
    component: Link,
    disabled: isSubmitting,
    size: "large",
    startIcon: /*#__PURE__*/_react.default.createElement(_Close2.default, null),
    sx: {
      borderRadius: '8px !important'
    },
    to: prevPath,
    variant: "outlined"
  }, t('commons.actions.cancel')), /*#__PURE__*/_react.default.createElement(_components.Button, {
    color: "primary",
    disabled: isSubmitting,
    onClick: handleSubmit,
    size: "large",
    startIcon: isSubmitting ? /*#__PURE__*/_react.default.createElement(_CircularProgress2.default, {
      color: "inherit",
      size: 16,
      thickness: 4
    }) : /*#__PURE__*/_react.default.createElement(_components.RocketIcon, null),
    sx: {
      borderRadius: '8px !important'
    },
    variant: "contained"
  }, t('commons.challenge_post.actions.launch')))));
}